import * as types from "./mutation-types.js";

export default {

  [types.SET_CAME_FROM_FULL_PATH](state, fullPath) {
    state.cameFromFullPath = fullPath;
  },

};
